import React from 'react';
import { PageLayout } from '../components/PageLayout';

export const PrivacyPage: React.FC = () => {
    return (
        <PageLayout>
            <div className="content-layout privacy-container">
                <div className="content__header">
                    <h1 id="page-title" className="content__title">Privacy Policy</h1>
                    <p className="privacy__header">Last updated: 04.06.2025</p>
                </div>
                <div className="content__body">
                    <div className="privacy-section">
                        <p>
                            This website uses Auth0 for user authentication. We do not collect or store any personal data beyond what is required to authenticate users via Auth0.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2 className='privacy__header'>1. What data is processed?</h2>
                        <p>When you log in, the following data may be processed through Auth0:</p>
                        <ul>
                            <li>Email address or other identifier</li>
                            <li>Name</li>
                            <li>IP address and technical metadata</li>
                        </ul>
                    </div>

                    <div className="privacy-section">
                        <h2 className='privacy__header'>2. Purpose</h2>
                        <p>
                            The data is used solely to identify you as an authenticated user and provide access to protected parts of the service.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2 className='privacy__header'>3. Legal basis</h2>
                        <p>
                            Processing is based on legitimate interest (GDPR Article 6(1)(f)) and/or contractual necessity (GDPR Article 6(1)(b)) if you maintain a user account.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2 className='privacy__header'>4. Third parties</h2>
                        <p>
                            We use Auth0 as our authentication provider. Auth0 acts as a data processor and processes data in accordance with their privacy policy and our data processing agreement.
                        </p>
                    </div>
                    
                    <div className="privacy-section">
                        <h2 className='privacy__header'>5. Your rights</h2>
                        <p>
                            You have the right to access, rectify, and delete your personal data. Contact us at <a href="mailto:andreas@jdkonsult.no">andreas@jdkonsult.no</a> to make a request.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2 className='privacy__header'>6. Cookies</h2>
                        <p>
                            Only technically necessary cookies are used for login functionality. No tracking or analytics cookies are set.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2 className='privacy__header'>7. Contact</h2>
                        <p>For privacy-related inquiries, please contact:</p>
                        <div className="contact-info">
                            <p>Jevnaker Digital Konsult</p>
                            <p>Contact: <a href="mailto:andreas@jdkonsult.no">andreas@jdkonsult.no</a></p>
                            <p>Organization: 931335111</p>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};

export default PrivacyPage;
